function showMenu() {
    var height = $(window).height();
    height -= 50;
    if (!$("#breadcrumb").hasClass("sticky2")) height -= 70;
    if ($(document).width() < 1024) {
        if ($("#nav").height() == 0) {
            $("#nav").animate({
                height: height,
                width: "100%"
            });
            $("#nav").addClass("shown");
        } else {
            $("#nav").animate({
                height: "0",
                width: "0"
            });
            $("#nav").removeClass("shown");
        }
    }
}

$(document).ready(function () {
    var navWidth = $("#nav").width();
    $("#nav").mouseenter(function () {
        if ($(window).width() > 1023) {
            $(this).stop().animate({
                width: "345"
            });
        }
    }).mouseleave(function () {
        if ($(window).width() > 1023) {
            $(this).stop().animate({
                width: navWidth
            });
        }
    });

    $("#menu").click(function () {
        showMenu();
    });
});


// Bestehendes Problem in Chrome: Scrollen fehlerhaft, sobald man Headerbereich verlässt.
// Durch das setzen von position=sticky im Breadcrumb ändert sich die Scrollposition 
//      -> add("sticky") bewirkt erneuten Aufruf des SCrollevents 
//      -> remove("sticky"), womit der Headerbereich weiter sichtbar bleibt;

//let scrollBreak = false;
//let oldScrollPosition = window.pageYOffset;
//let scrollDown = false;

//$(window).scroll(function () {
//    var navbar = document.getElementById("nav");
//    var breadcrumb = document.getElementById("breadcrumb");
//    var content = document.getElementById("content");
//    var sticky = 70;
//    var height = $(window).height();

//    //let currentScrollPosition = window.pageYOffset;
//    //scrollDown = currentScrollPosition > oldScrollPosition;

//    if (window.pageYOffset >= sticky) {
//        $('.dbhBegruessungAlpha').hide();
//        if ($(document).width() < 1024) {
//            navbar.classList.add("sticky");
//            if ($("#nav").hasClass("shown")) $("#nav").height(height - 50);
//            breadcrumb.classList.add("sticky2");
//        } else {
//            //if (scrollDown) {
//                    //scrollBreak = true;
//                    navbar.classList.add("sticky");
//                    breadcrumb.classList.add("sticky");
//                    $('#content').css("margin-top", 50);

//                //setTimeout(() => {
//                //    scrollBreak = false;
//                //}, 150);
//            //}
//        }
//    } else {
//        $('.dbhBegruessungAlpha').show();
//        if ($(document).width() < 1024) {
//            navbar.classList.remove("sticky");
//            if ($("#nav").hasClass("shown")) $("#nav").height(height - 120);
//            breadcrumb.classList.remove("sticky2");
//        } else {
//            //if (!scrollBreak) {
//                navbar.classList.remove("sticky");
//                breadcrumb.classList.remove("sticky");
//                $('#content').css("margin-top", 0);
//            //}
//        }
//    }
//    //oldScrollPosition = currentScrollPosition;
//});

